import client from "@/api/client"
import { WorkspaceWithRole } from "@/api/sdk"
import { createMutation } from "react-query-kit"

export const useSwitchWorkspaceMutation = createMutation({
  mutationFn: (workspace: Partial<WorkspaceWithRole>) =>
    client.api.workspaceControllerSwitchWorkspace(workspace.id!).then(res => res.data),
})
